import { createStore, applyMiddleware } from 'redux';
import * as actionCreators from '../action';
import moment from 'moment';
// REDUCER FOR TASK LIST
export function imageDetails(state = [], action) {
    switch (action.type) {
        case 'IMAGE_DETAILS':
            console.log("================== Inside EVENT List ===================");
            return action.detail
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/image.js